import { createContext } from 'react';
import { QUERY_KEYS_BENEFITS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const PaymentsChartsDataContext = createContext();

const PaymentsChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();

    const monthlyFilterParams = {
        year: filters.year?.value || '',
        month: filters.month?.value || '',
        location: filters.unidade?.value || '',
        city: filters.cidade?.value || '',
        siafi_code: filters.cidade?.siafi_code || ''
    };

    const yearlyFilterParams = {
        year: '',
        month: '',
        location: filters.unidade?.value || '',
        city: filters.cidade?.value || '',
        siafi_code: filters.cidade?.siafi_code || ''
    };

    const {
        data: monthlyData,
        isLoading: isMonthlyLoading,
        isError: isMonthlyError
    } = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.FAMILY_ALLOWANCE_PAYMENTS,
            url: 'governanceroom/socialdashboard/benefits/familyAllowancePayments/payments'
        },
        monthlyFilterParams
    );

    const {
        data: yearlyData,
        isLoading: isYearlyLoading,
        isError: isYearlyError
    } = useChartsData(
        {
            key: `${QUERY_KEYS_BENEFITS.FAMILY_ALLOWANCE_PAYMENTS}-yearly`,
            url: 'governanceroom/socialdashboard/benefits/familyAllowancePayments/payments'
        },
        yearlyFilterParams
    );

    const normalizePayments = (data = []) =>
        data.map((item) => ({
            ...item,
            sum_value: Number(item.sum_value),
            avg_value: Number(item.avg_value)
        }));

    const buildYearlyPayments = (data = []) => {
        const grouped = data.reduce((acc, item) => {
            const year = item.ano;

            if (!acc[year]) {
                acc[year] = {
                    ano: year,
                    sum_value: 0,
                    avg_value: 0,
                    count: 0
                };
            }

            acc[year].sum_value += Number(item.sum_value) || 0;
            acc[year].avg_value += Number(item.avg_value) || 0;
            acc[year].count += 1;

            return acc;
        }, {});

        return Object.values(grouped)
            .map((item) => ({
                ano: item.ano,
                sum_value: item.sum_value,
                avg_value: item.count ? item.avg_value / item.count : 0
            }))
            .sort((a, b) => Number(a.ano) - Number(b.ano));
    };

    const chartData = {
        paymentsMonth: normalizePayments(monthlyData || []),
        paymentsYear: buildYearlyPayments(normalizePayments(yearlyData || []))
    };

    return (
        <PaymentsChartsDataContext.Provider
            value={{
                chartData,
                filters,
                filterParams: monthlyFilterParams,
                isLoading: isMonthlyLoading || isYearlyLoading,
                isError: isMonthlyError || isYearlyError,
                data: monthlyData
            }}
        >
            {children}
        </PaymentsChartsDataContext.Provider>
    );
};

export default PaymentsChartsDataProvider;
